import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Accounts } from 'meteor/accounts-base';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';
import { handleDiscordOauth2Code } from '/imports/api/oauth2';
import { strings } from '/imports/strings';
import { defer } from '/imports/utils';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Oauth2ThankYouPage } from '/imports/ui/Oauth2ThankYouPage';
import { isAndroid } from '/imports/android';
import { isIos } from '/imports/ios';

const DiscordOauth2RedirectPageStyled = styled(SignedOutPageStyled)`
`;

/**
 * Handles the Discord OAuth2 redirect, logging in on web or deferring to the mobile app.
 */
export const DiscordOauth2RedirectPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  const error = params.get('error');
  const state = JSON.parse(window.atob(params.get('state') || '') || '{}');
  const platform = state.platform;
  const search = new URLSearchParams(state.search);
  const referralCode = search.get('a') || undefined;
  /**
   * Exchanges the OAuth2 code for a JWT and logs the user in, or surfaces any error.
   */
  const redirectForBrowser = async () => {
    if (code) {
      try {
        const jwt = await handleDiscordOauth2Code.call({ code, referralCode });
        Accounts.callLoginMethod({
          methodArguments: [{ jwt }], userCallback: (error) => {
            if (error) toast.error(strings.AnErrorOccurredPleaseTryAgainOrContactSupport()) && console.log(error);
            else navigate('/');
          }
        });
      }
      catch (error) {
        console.log(error);
        toast.error(strings.AnErrorOccurredPleaseTryAgainOrContactSupport());
      }
    }
    else if (error) {
      console.log(error);
      toast.error(`${error}`);
    }
  };
  /**
   * Stops the loading state so the thank-you page shows for the native mobile app.
   */
  const redirectForMobile = () => {
    defer(() => setLoading(false));
  };
  useEffect(() => {
    if (!isAndroid() && platform === 'android') redirectForMobile();
    else if (!isIos() && platform === 'ios') redirectForMobile();
    else redirectForBrowser();
  }, []);
  return (
    <DiscordOauth2RedirectPageStyled className="page">
      {
        loading ?
          <LoadingFullScreen />
          :
          <Oauth2ThankYouPage />
      }
    </DiscordOauth2RedirectPageStyled>
  );
};